<template>
	<div>
		<router-view />
	</div>

</template>

<script>
    export default {
        name: "conf"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/configuration/conf.vue